module.exports = __webpack_public_path__ + "static/media/sport.4988c7fd.png";